<template>
    <kgr-club-sales-list-config-data-provider
        :club-id="clubId"
        :callback="onClubSalesListConfigLoaded"
    >
        <kgr-club-sales-list-item-data-provider
            :club-id="clubId"
            :callback="onClubSalesListItemsLoaded"
        >
            <kgr-form-scaffold
                save-button-disabled
                :with-primary-buttons="false"
                @backBtnClicked="onBack"
            >
                <kgr-member-article-sales-form
                    :club-id="clubId"
                    :member-id="memberId"
                    :available-fees="availableFees"
                    :club-sales-list-config="clubSalesListConfig"
                    :has-sepa-debit="hasSepaDebit"
                />
            </kgr-form-scaffold>
        </kgr-club-sales-list-item-data-provider>
    </kgr-club-sales-list-config-data-provider>
</template>

<script>
import ClubSalesListConfigDataProvider from '../../components/data-provider/ClubSalesListConfigDataProvider';
import ClubSalesListItemDataProvider from '../../components/data-provider/ClubSalesListItemDataProvider';
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberArticleSalesForm from '../../components/members/article-sales/MemberArticleSalesForm';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-club-sales-list-item-data-provider': ClubSalesListItemDataProvider,
        'kgr-club-sales-list-config-data-provider': ClubSalesListConfigDataProvider,
        'kgr-member-article-sales-form': MemberArticleSalesForm,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        hasSepaDebit: {
            type: Boolean,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            availableFees: [],
            clubSalesListConfig: null,
        };
    },
    methods: {
        onBack() {
            window.location = this.overviewUrl;
        },
        onClubSalesListItemsLoaded(items) {
            this.availableFees = items;
        },
        onClubSalesListConfigLoaded(clubSalesListConfig) {
            this.clubSalesListConfig = clubSalesListConfig;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
